//#region src/core/i18n/locales/th.ts
var th_default = {
	buttons: {
		play: "เล่น",
		pause: "หยุดชั่วคราว",
		replay: "เล่นซ้ำ",
		mute: "ปิดเสียง",
		unmute: "ยกเลิกการปิดเสียง"
	},
	seek: {
		forward: "ข้ามไปข้างหน้า {seconds} วินาที",
		backward: "ข้ามไปข้างหลัง {seconds} วินาที"
	},
	fullscreen: {
		enter: "แบบเต็มหน้าจอ",
		exit: "ออกจากเต็มหน้าจอ"
	},
	captions: {
		enable: "เปิดคำบรรยาย",
		disable: "ปิดคำบรรยาย"
	},
	pip: {
		enter: "การเล่นภาพควบคู่",
		exit: "ออกจากการเล่นภาพควบคู่"
	},
	live: {
		playing: "กำลังถ่ายทอดสด",
		seekToEdge: "ไปยังจุดถ่ายทอดสด",
		badge: "ถ่ายทอดสด"
	},
	cast: {
		start: "เริ่มแคสต์",
		stop: "หยุดแคสต์",
		connecting: "กำลังเชื่อมต่อ"
	},
	airplay: {
		start: "เริ่ม AirPlay",
		stop: "หยุด AirPlay"
	},
	slider: { seek: "ค้นหา" },
	time: {
		current: "เวลาปัจจุบัน",
		duration: "ระยะเวลา",
		remaining: "เวลาที่เหลือ",
		elapsedSuffix: "เวลาที่ผ่านไป {duration}",
		durationSuffix: "ระยะเวลา {duration}",
		remainingSuffix: "เหลือ {duration}",
		showElapsed: "แสดงเวลาที่ผ่านไป, {duration}.",
		showDuration: "แสดงระยะเวลา, {duration}.",
		showRemaining: "แสดงเวลาที่เหลือ, {duration}.",
		toggleElapsed: "สลับระหว่างเวลาที่ผ่านไปกับเวลาที่เหลือ",
		toggleDuration: "สลับระหว่างระยะเวลากับเวลาที่เหลือ",
		position: "{current} ของ {duration}",
		unknown: "ไม่ได้โหลดสื่อ ไม่ทราบเวลา"
	},
	playback: { rate: "อัตราการเล่น {rate}" },
	volume: {
		mutedValue: "{percent}, ปิดเสียง",
		muted: "ปิดเสียงแล้ว",
		label: "ระดับเสียง",
		value: "ระดับเสียง {value}"
	},
	status: {
		captionsOn: "เปิดคำอธิบายภาพ",
		captionsOff: "ปิดคำอธิบายภาพ",
		paused: "หยุดชั่วคราว",
		playing: "กำลังเล่น",
		fullscreen: "เต็มหน้าจอ",
		pip: "ภาพซ้อนภาพ",
		exitPip: "ออกจากภาพซ้อนภาพ",
		seekedTo: "เลื่อนไปที่ {time}"
	},
	container: { label: "เครื่องเล่นสื่อ" },
	errors: {
		aborted: "คุณยกเลิกการเล่นสื่อแล้ว",
		network: "ข้อผิดพลาดของเครือข่ายทำให้การดาวน์โหลดสื่อไม่สำเร็จเป็นบางส่วน",
		decode: "การเล่นสื่อถูกยกเลิกเนื่องจากปัญหาเกี่ยวกับความเสียหาย หรือเนื่องจากสื่อใช้ฟีเจอร์ที่เบราว์เซอร์ของคุณไม่รองรับ",
		source: "ไม่สามารถโหลดสื่อได้ โดยอาจเป็นเพราะเซิร์ฟเวอร์หรือเครือข่ายล้มเหลว หรือเพราะรูปแบบไม่ได้รับการรองรับ",
		encrypted: "สื่อถูกเข้ารหัสลับแล้ว และเราไม่มีคีย์ที่จะถอดรหัสลับดังกล่าว",
		unplayable: "เครื่องเล่นสื่อไม่รองรับสื่อนี้",
		title: "เกิดข้อผิดพลาด",
		unexpected: "เกิดข้อผิดพลาด กรุณาลองอีกครั้ง"
	},
	common: {
		empty: "",
		ok: "ปิด"
	},
	menu: {
		settings: "การตั้งค่า",
		quality: "คุณภาพ",
		audio: "เสียง",
		default: "ค่าเริ่มต้น",
		speed: "ความเร็ว",
		captions: "คำบรรยาย",
		playbackRate: "อัตราการเล่น",
		back: "กลับ",
		off: "ปิด",
		auto: "อัตโนมัติ",
		autoWithLabel: "อัตโนมัติ ({label})",
		subtitles: "คำบรรยาย"
	}
};
//#endregion
export { th_default as default };

//# sourceMappingURL=th.js.map